// @ts-nocheck
/* tslint:disable */
import { config } from '@/config/config';

class ConnectWidget {
  public addWebAssistant(userId: string, token: string) {
    this.loadWidget(() => {
      Connect.init({
        workspaceId: config().webAssistantWorkspaceId,
        contact: {
          userId: userId,
          token: token,
        },
      });
    });
  }

  public async update(userId: string, token: string) {
    if (Connect && Connect.update) {
      await Connect.update({
        contact: {
          userId,
          token,
        },
      });
    }
  }

  private loadWidget(callback) {
    'use strict';
    'function' != typeof Object.assign &&
      (function () {
        Object.assign = function (a) {
          if (a === void 0 || null === a) throw new TypeError('Cannot convert undefined or null to object');
          for (var b, c = Object(a), d = 1; d < arguments.length; d++)
            if (((b = arguments[d]), void 0 !== b && null !== b)) for (var e in b) b.hasOwnProperty(e) && (c[e] = b[e]);
          return c;
        };
      })(),
      (function (a, b, c, d) {
        var e,
          f = [],
          g = [];
        (a[c] = {
          init: function () {
            for (var a = arguments.length, b = Array(a), c = 0; c < a; c++) b[c] = arguments[c];
            e = b;
            var d = {
              then: function (a) {
                return f.push({ type: 'then', next: a }), d;
              },
              catch: function (a) {
                return f.push({ type: 'catch', next: a }), d;
              },
            };
            return d;
          },
          on: function () {
            for (var a = arguments.length, b = Array(a), c = 0; c < a; c++) b[c] = arguments[c];
            g.push(b);
          },
        }),
          (a.__onConnectHostReady__ = function (b) {
            if ((delete a.__onConnectHostReady__, (a[c] = b), e))
              for (var d, h = b.init.apply(b, e), j = 0; j < f.length; j++)
                (d = f[j]), (h = 'then' === d.type ? h.then(d.next) : h.catch(d.next));
            for (var j = 0; j < g.length; j++) b.on.apply(b, g[j]);
          });
        var h = new XMLHttpRequest();
        h.addEventListener('load', function () {
          try {
            var a = this.response;
            if (('string' == typeof a && (a = JSON.parse(a)), a.url)) {
              var c = b.getElementsByTagName('script')[0],
                d = b.createElement('script');
              (d.async = !0), (d.src = a.url), c.parentNode.insertBefore(d, c);
            }
            callback();
          } catch (a) {}
        }),
          h.open('GET', `${config().webAssistantHost}/v1/loader/` + d, !0),
          (h.responseType = 'json'),
          h.send();
      })(window, document, 'Connect', config().webAssistantWorkspaceId);
  }
}

const connectWidget = new ConnectWidget();
export default connectWidget;
